import React from 'react';
const cards = ['Visa', 'Mastercard', 'Cabal', 'Naranja X', 'American Express'];
export function PaymentMethods() {
  return <div className="mt-8 border-t border-brand-line pt-7" data-id="element-122" data-mp="3lrvvuab3pq8e">
      <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-brand-gray" data-id="element-123" data-mp="3gr7yl6wa4d5q">
        Medios de pago
      </p>
      <div className="mt-4 flex flex-wrap items-center justify-center gap-2.5" data-id="element-124" data-mp="3brbs910409n0">
        <span className="inline-flex items-center gap-2 rounded-lg bg-[#009EE3] px-3 py-2 text-[11px] font-semibold text-white shadow-sm" data-id="element-125" data-mp="36tttu4jpxct9">
          <span className="flex h-4 w-4 items-center justify-center rounded-full bg-white text-[9px] font-bold text-[#009EE3]" aria-hidden="true" data-id="element-126" data-mp="3210phhs5w6hp">
            MP
          </span>
          Mercado Pago
        </span>
        {cards.map(card => <span key={card} className="rounded-lg border border-brand-line bg-brand-alt px-3 py-2 text-[11px] font-semibold text-brand-navy" data-id="element-127" data-mp="2o1hfskjpcn3a">
            {card}
          </span>)}
      </div>
      <p className="mt-4 text-[11px] text-brand-gray" data-id="element-128" data-mp="18z5vw9ngkrdo">
        Tarjetas de crédito y débito argentinas · Hasta 3 cuotas con Mercado
        Pago
      </p>
    </div>;
}